import { Button, Card, Col, Input, Row, Spin } from 'antd'
import React, { useEffect, useState } from 'react'
import { SearchOutlined } from "@ant-design/icons";
import { videoService } from '../../../services';
import { changeDocumentTitle } from "../../../utils/title";

function CustomerKnowledge() {

    const [videos, setVideos] = useState([])
    const [search, setSearch] = useState(null)
    const [searchInput, setSearchInput] = useState("");
    const [pagination, setPagination] = useState({
        current: 1,
        total: 0,
        pageSize: 10,
    });
    const [loading, setLoading] = useState(false)
    const handleSearch = () => {
        setSearch(searchInput);
    };;
    const initialize = async (page = 1, pageSize = pagination.pageSize, search = null) => {
        setLoading(true);
        const { success, data, message } = await videoService.fetch(page, pageSize, search);
        console.log("data", data)
        setLoading(false);
        if (success) {
            setVideos(data.data);
            setPagination((prev) => ({
                ...prev,
                total: data.total,
                current: page,
                pageSize,
            }));
        } else {
            console.error(`Error fetching vendors: ${message || "Unknown error"}`);
        }
    };
    useEffect(() => {
        changeDocumentTitle("Knowledge Base");
        initialize(pagination.current, pagination.pageSize, search);
    }, [search]);
    return (
        <div>
            <div className='flex justify-center'>
                <div className='w-[45%] flex flex-col justify-center items-center'>
                    <h1 className='text-xl font-bold'>Knowledge Base</h1>
                    <p className='text-center text-sm font-medium'>A premium web application with an integrated knowledge base to guide you step by step.</p>
                    <div className="p-1 w-full rounded-lg border flex items-center bg-white shadow-sm ">
                        <Input
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            placeholder="Search Videos Title"
                            className="border-none focus:shadow-none px-2  bg-transparent" />
                        <Button
                            type='primary'
                            onClick={handleSearch}
                            className="flex items-center justify-center p-5 text-white rounded-md"
                            icon={<SearchOutlined style={{ fontSize: "14px" }} />}>
                            Search
                        </Button>
                    </div>
                </div>
            </div>
            <div className='overflow-x-hidden h-[75vh] mt-12'>
                {loading ? (
                    <div className="flex justify-center items-center w-full h-[300px]">
                        <Spin size="large" />
                    </div>
                ) : (
                    <Row gutter={16} >
                        {videos.map((video, index) => (
                            <div className='overflow-y-auto mb-12'>
                                <Col span={8} className='mb-12 '  >
                                    <Card
                                        hoverable
                                        style={{ width: 310 }}
                                        bodyStyle={{ height: "120px" }}
                                        cover={
                                            <video
                                                src={video.video_url}
                                                controls
                                                muted
                                                draggable={false}
                                                className="card-video"
                                            />
                                        }
                                    >
                                        <div className="flex flex-col gap-1 mt-0">
                                            <h1 className="m-0 p-0 font-semibold text-base">{video.title}</h1>
                                            <p className="m-0 p-0 text-xs font-light truncate">{video.description}</p>
                                        </div>
                                    </Card>
                                </Col>
                            </div>
                        ))}
                    </Row>
                )}
            </div>

            <style>
                {
                    `
   .card-video {
  height: 180px;
  width: 100%;
  object-fit: cover;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

/* When video is fullscreen */
.card-video:fullscreen {
  height: 100%;
  width: 100%;
  object-fit: contain; /* show full video without cropping */
  border-radius: 0;
}
        `
                }
            </style>
        </div>
    )
}

export default CustomerKnowledge